import Reveal from "@/components/common/Reveal";
import { LEADERSHIP } from "@/data/content";

export default function Leadership() {
  return (
    <>
      <section className="pt-20 md:pt-24 pb-6 md:pb-10 max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14" data-testid="leadership-hero">
        <div className="mono-label text-zinc-500">Leadership</div>
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em] font-light mt-3 max-w-4xl">
          The people behind <em className="not-italic text-[#BE1E2D] font-normal">every</em> signature.
        </h1>
        <p className="text-zinc-600 text-base md:text-lg max-w-xl mt-6 leading-relaxed">
          A cross-disciplinary leadership team with decades of combined experience in engineering, construction management and client delivery.
        </p>
      </section>

      {/* LEADERSHIP GRID */}
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 pb-16 md:pb-24">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-6">
          {LEADERSHIP.map((p, i) => (
            <Reveal key={p.name} delay={(i % 5) * 0.06}>
              <article data-testid={`leadership-card-${i}`}>
                <div
                  className="aspect-square flex items-center justify-center relative overflow-hidden"
                  style={{ backgroundColor: p.accent }}
                >
                  <div className="absolute inset-0 opacity-20" style={{
                    backgroundImage: "radial-gradient(circle at 30% 20%, rgba(255,255,255,0.6), transparent 60%)"
                  }} />
                  <span className="relative font-display text-white text-4xl md:text-5xl leading-none font-light tracking-tighter select-none">
                    {p.initials}
                  </span>
                  <div className="absolute bottom-2.5 left-2.5 right-2.5 flex items-center justify-between">
                    <span className="mono-label text-white/70 text-[8px]">0{i + 1}</span>
                    <span className="w-4 h-px bg-white/60" />
                  </div>
                </div>
                <div className="mt-3">
                  <h3 className="font-display text-base md:text-lg leading-tight">{p.name}</h3>
                  <div className="text-zinc-500 text-[10px] mt-1 uppercase tracking-widest">{p.role}</div>
                  <p className="text-zinc-600 mt-2 leading-relaxed text-[12px]">{p.bio}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      {/* COMPLIANCE / REGISTRATIONS */}
      <section className="bg-[#0A0A0A] text-white py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="mono-label text-zinc-500">Governance</div>
            <h2 className="font-display text-3xl md:text-4xl mt-4 leading-[1.05] tracking-tight">
              Fully registered. Tax-compliant. Audit-ready.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 grid sm:grid-cols-2 gap-px bg-zinc-800">
            {[
              { k: "CAC", v: "Corporate Affairs Commission" },
              { k: "FIRS", v: "Tax Clearance & VAT" },
              { k: "PENCOM", v: "Pension Compliance" },
              { k: "ITF", v: "Industrial Training Fund" },
              { k: "NSITF", v: "Employee Compensation" },
              { k: "BPP", v: "Bureau of Public Procurement" },
            ].map((c) => (
              <div key={c.k} className="bg-[#0A0A0A] p-5 min-h-[100px]">
                <div className="font-display text-2xl text-[#BE1E2D]">{c.k}</div>
                <div className="text-zinc-400 text-xs mt-1.5">{c.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
